import React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomColumnsPanel } from './CustomColumnsPanel';
import { CustomColumnsEntityPageState } from '../../state/CustomColumnsEntityPageState';

function _CustomColumnsEntityPagePanelEntry() {
  const state = CustomColumnsEntityPagePanelEntry.state;

  if (!state) {
    return null;
  }

  return <CustomColumnsPanel state={state} />;
}

export const CustomColumnsEntityPagePanelEntry = observer(
  _CustomColumnsEntityPagePanelEntry,
) as typeof _CustomColumnsEntityPagePanelEntry & {
  state?: CustomColumnsEntityPageState;
};
